var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStarFilled = function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.9019L6.12215 20.0902L6.38697 13.8238L2.48943 8.90983L8.53096 7.22527L12 2L15.469 7.22527L21.5106 8.90983L17.613 13.8238L17.8779 20.0902L12 17.9019Z",
    fill: "currentColor"
  })));
};

export { SvgStarFilled as ReactComponent };
export default __webpack_public_path__ + "80ba9f857450d06e52d1b01e6620ebab.svg";